<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M16,5C16,5,13.48,7.11,11.04,6.99C11.03,4.89,10.39,0.23,5,0C5,0,7.11,2.54,6.96,4.99C4.86,5.01,0.23,5.65,0,11C0,11,2.56,8.88,5.02,9.05C5.04,11.16,5.69,15.77,11,16C11,16,8.91,13.46,9.06,11.01C11.17,10.99,15.77,10.33,16,5C16,5,16,5,16,5ZM8,9.5C7.17,9.5,6.5,8.83,6.5,8C6.5,7.17,7.17,6.5,8,6.5C8.83,6.5,9.5,7.17,9.5,8C9.5,8.83,8.83,9.5,8,9.5C8,9.5,8,9.5,8,9.5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Ninja',
} as DefineComponent
</script>
